import React, { useState, useEffect, useRef } from 'react';

const Notification = (props) => {
  return <div className="notification-container">{props.description}</div>;
};

const NotificationWithTimeout = (props) => {
  const [active, setActive] = useState(true);
  let timeout = useRef();

  useEffect(() => {
    timeout.current = setTimeout(() => {
      setActive(false);
    }, 2000);
    return () => {
      clearTimeout(timeout.current);
    };
  }, []);

  if (!active) return null;
  return (
    <Notification data-testid="copy-modal" description={props.description} />
  );
};

export default NotificationWithTimeout;
